// Lib
import { DropTarget } from 'react-dnd';
import { NativeTypes } from 'react-dnd-html5-backend';
import ReactDOM from 'react-dom';
import { isEmpty } from 'lodash/fp';

export const handleFileDrop = (props, monitor, component) => {
    const { uploadMultipleFiles, uploadFile, transactionId } = props;
    const { files } = monitor.getItem();

    if (isEmpty(files)) return;

    if (uploadMultipleFiles) {
        const uploadPromise = uploadMultipleFiles(files, transactionId);

        return {
            handledBy: ReactDOM.findDOMNode(component),
            uploadPromise,
        };
    }

    const file = monitor.getItem().files && monitor.getItem().files[0];
    if (file && uploadFile) {
        const uploadPromise = uploadFile(file, transactionId);

        return {
            handledBy: ReactDOM.findDOMNode(component),
            uploadPromise,
        };
    }
};

const defaultDropSpec = {
    drop: handleFileDrop,
};

const defaultDropCollect = (connector, monitor) => ({
    connectFileDropTarget: connector.dropTarget(),
    fileIsHovered: monitor.canDrop() && monitor.isOver(),
    fileCanDrop: monitor.canDrop(),
});

export default (customSpec, customCollect) => {
    const collect = customCollect || defaultDropCollect;
    const spec = {
        ...defaultDropSpec,
        ...customSpec,
    };

    return DropTarget(NativeTypes.FILE, spec, collect);
};
